/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// window.WEBSPELLCHECKER_CONFIG = {
//   autoSearch: true,
//   serviceId: '1:Ge2we2-2Uu0D1-q71tW3-viGzV-UoRJx1-5Oh9I-aGCXm1-rMwCh4-fbG2u2-z0csa1-mfPvk-C99',
//   enableGrammar: true,
// };

(function() {
  var library;

  function createLibraryScriptNode(url) {
    var node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
    return node;
  }

  /**
   * Loads wsc library only one time
   */
  function loadLibrary(url) {
    if (library == null) {
      library = new Promise(function (resolve, reject) {
        var node = createLibraryScriptNode(url);
        node.onload = function () {
          library = Promise.resolve(void 0);
          resolve();
        };
        node.onerror = function () {
          library = void 0;
          reject();
        };
      });
    }
    return library;
  }

  function onEditorReady(editor, onInstanceReady) {
    loadLibrary('https://svc.webspellchecker.net/spellcheck31/wscbundle/wscbundle.js')
    // loadLibrary('/wscbundle.js')
      .then(function() {
        onInstanceReady(WEBSPELLCHECKER._createApp({
          container: editor.iframeElement,
          autoStartup: true,
          serviceId: editor.getParam('scayt_serviceId'),
          spellcheckLang: editor.getParam('scayt_spellcheckLang'),
          enableGrammar: true,
        }));
      });
  }

  tinymce.PluginManager.add('proofreader', function(editor) {
    var wscInstance;
    var onInstanceReady = function (instance) {
      wscInstance = instance;
    };

    editor.on('init', function(event) {
      onEditorReady(event.target, onInstanceReady);
    });
    editor.on('remove', function() {
      if (wscInstance) {
        wscInstance.destroy();
      }
    });
  });
})();
